import { AcsEventNameDisplay } from "../enums/acsEventName";
import { EventType } from "../enums/eventType";
import { ManagementEventNameDisplay } from "../enums/managementEventName";
import { RoomStatusAlarmNameDisplay } from "../enums/roomStatusAlarmName";
import { SiteEventNameDisplay } from "../enums/SiteEventName";
import { SystemErrorNameDisplay } from "../enums/systemErrorName";

const EVENT_TYPE_DESCRIPTION_MAP: { [key in EventType]: Map<number, string>; } = {
    [EventType.AcsEvent]: AcsEventNameDisplay,
    [EventType.ManagementEvent]: ManagementEventNameDisplay,
    [EventType.SystemError]: SystemErrorNameDisplay,
    [EventType.RoomStatusAlarm]: RoomStatusAlarmNameDisplay,
    [EventType.SiteEvent]: SiteEventNameDisplay,
}

export function getEventNameDescription(eventType: EventType, eventName: number): string | undefined {
    return EVENT_TYPE_DESCRIPTION_MAP[eventType].get(eventName) || "";
}
